<template>
  <div class="paymentSuccess" style="margin-top: 160px;">
    <p class="pay-title">
      <img :src="icon_img">
      <span :style="{'color':payment_color}">{{payment_name}}支付</span>
    </p>
    <div class="shop-carBox comWidth">

      <div class="flow_main" v-if="payResult" :style="{'border-color':payment_color}">
        <div style="height: 200px; " class="box7">
          <p id="qrcode" style="width: 200px;height: 200px;margin: 0 30px 0 0;display: inline-block"></p>
          <iframe id="iframeContent"
                  style="width: 200px;
                  height: 200px;
                  margin: 0 30px 0 0;
                  display: none;
                  frameborder:0
">

          </iframe>
          <p class="box7-child" :style="{'color':payment_color}">
            <img src="../../assets/icon/saoma.png" alt="">
            <br>
            请使用{{payment_name}}“扫一扫”<br>
            扫描二维码支付
          </p>
        </div>


        <p :style="{'color':payment_color}">實付款： ¥ {{amount}}</p>
      </div>
      <div class="payFail" v-else>
        <h3 style="font-size: 20px;">系统信息</h3>
        <div style="margin: 20px auto;">
          <p class="word-information">{{ errorMessage }}</p>
        </div>
        <p style="display:inline-block;" >
          <a class="btn btn-primary" href="javascript:history.back(-1)">返回上一页</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  //api
  import {notify,getHipopayQR,orderPayQuery} from '@/api/order';
  import QRCode from 'qrcodejs2';
  import { Loading } from 'element-ui';
  export default {
    name: 'QRcodePage',
    data () {
      return {
        params:{
          succ:this.$route.query.succ,
          amount:this.$route.query.amount,
          billno:this.$route.query.billno
        },
        amount:'0.00',
        payResult: true,
        errorMessage: '',
        orderid:this.$route.query.orderid,
        timer:null,
        icon_img:null,
        payment_name:null,
        payment_color:null,
      }
    },
    methods:{
        qrcode () {
            getHipopayQR(this.orderid,this.$route.query.payment_method).then(res =>{
                //检查订单是否已支付或者已失效

                if (res.data==422){
                    this.$message.error('订单已失效，或者订单已支付')
                    setTimeout(() =>{
                        this.$router.push({
                            path: `/OrderDetails?orderid=`+this.orderid,
                        })
                    },3000)
                }
                res = res.data;
                //生成二维码
                if (res.response.qrcode_url !== undefined){
                    let qrcode = new QRCode('qrcode', {
                        width: 200,
                        height: 200, // 高度
                        text: res.response.qrcode_url // 二维码内容
                        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                        // background: '#f0f'
                        // foreground: '#ff0'
                    })
                }
                if (res.response.pay_url !== undefined){

                    document.getElementById('qrcode').style.display = 'none'
                    document.getElementById('iframeContent').style.display = 'inline-block'
                    document.getElementById('iframeContent').setAttribute('src',res.response.pay_url)
                    document.getElementById('iframeContent').setAttribute('frameborder',0)
                    document.getElementById('iframeContent').setAttribute('scrolling','no')
                }
                console.log(this.qrcode_url)

                this.amount = res.response.amount;

                let self = this; // 定义一个变量指向vue实例
                //定时查询支付状态
                this.timer = window.setInterval(function (orderid) {
                    orderPayQuery(orderid).then(res =>{
                        if(res.data==true){
                            self.$router.push({
                                path: `/PaymentSuccess?orderid=`+self.orderid+`&amount=`+self.amount,
                            })
                        }
                    })
                }, 3000,this.orderid);
            })

        },
        /*支付回调*/
      getCallBack(){
 /*       var url = location.href; //获取url中"?"符后的字串
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
          var str = (url.split('?'))[1];
          var strs = str.split("&");
          for(var i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
          }*/
/*          this.params.succ = theRequest.succ
          this.params.amount = theRequest.amount
          this.params.billno = theRequest.billno*/
          if( this.params.succ  &&　this.params.amount  && this.params.billno  ){
            notify(this.$route.query).then(res=>{
                    this.payResult = true
                  }).catch(error => {
                    if (error.response.status === 422) {
                      this.payResult = false
                      this.errorMessage = error.response.data.message
                    }
                  })
//          }
        }
      }
    },
      destroyed(){
          if(this.timer) { //如果定时器在运行则关闭
              clearInterval(this.timer);
          }
      },
    created(){
          if (this.$route.query.payment_method==0){
              this.icon_img = '/static/img/weixin.jpg';
              this.payment_name = '微信';
              this.payment_color = '#40af34'
          }
        if (this.$route.query.payment_method==1){
            this.icon_img = '/static/img/zhifubao.jpg';
            this.payment_name = '支付宝';
            this.payment_color = '#00AAEF'
        }

      window.scrollTo(0,0)
      this.getCallBack()
        this.$nextTick(() => {
            this.qrcode()
        })
    },
    mounted(){
      var _this = this
        window.addEventListener("popstate", function(e) { // 监听返回键
            _this.$router.push({
                name:'MyOrder'
            })
        }, false);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .pay-title{
    text-align: center;
    font-size: 34px;
    margin-bottom: 20px;
  }

  .pay-title>img{
    width: 50px;

  }
  .box7{

    font-size:0;
    display: table;
    width: 451px;
    margin: 0 auto;
  }
  .box7-child{
    display: table-cell;
    vertical-align: middle;
  }

.word-information{
    color: #8b8b8b;
    background-color: #f7f7f7;
    padding: 50px 10px;
    font-size: 18px;
    line-height: 36px;
}
.btn-primary{
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}
 .paymentSuccess{
   .flow_main{
     height: 282px;
     width: 100%;
     padding: 20px 99px;
     border:2px solid #40af34;
     margin-bottom: 100px;
     text-align: center;
     p{
       margin-top:20px;
       color: #40af34;
       font-size:20px;
       img{
         width: 60px;
         height: 60px;
         margin-right: 10px;
       }
       span{
         font-size: 34px;
         font-weight: bold;
         text-align: center;
         vertical-align: middle;
       }
       button{
         background: red;
         color: #fff;
         display: inline-block;
         width: 130px;
         height: 35px;
         border-radius: 5px;
         margin: 0 10px;
         transition: all 0.1s linear;
         &:hover{
            background: #ff4850;
          }
       }
     }
     .reBtn{
       margin-top: 60px;
     }
   }
   .payFail{
     height: 282px;
     text-align: center;
     width: 100%;
   }
 }
</style>



// WEBPACK FOOTER //
// src/pages/detailsPage/QRcodePage.vue